import { string, shape } from 'prop-types';

export default shape({
    modelId: string,
});
